// src/appwriteConfig.js
import { Account, Client } from "appwrite";

const client = new Client();

client
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT) // Set only once
  .setProject(process.env.REACT_APP_PROJECT_ID);

export const account = new Account(client);
export default client;
